import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { CopilotResultViewExternalSiteMap } from '@bingads-webui/global-search-copilot';
import { allSiteMap } from '@bingads-webui-react/with-site-map';
import { HELP_APEX } from './consts';

export const CopilotSearchResults = (props) => {
  const {
    hideSuggestionBox,
    i18n,
    logger,
    isNewLogo,
  } = props;
  const [searchQuery, setSearchQuery] = useState('');
  const [renderedFirstTime, setRenderedFirstTime] = useState(false);

  useEffect(() => {
    $('#searchquery').on('keydown', (e) => {
      setSearchQuery(e.target.value);
    });

    $('#searchquery').on('keyup', (e) => {
      setSearchQuery(e.target.value);
    });
  }, []);

  const closeApexPopUp = useCallback(() => {
    if (hideSuggestionBox) {
      hideSuggestionBox();
    }
    window.apex_glb.closeHelpView();
    setSearchQuery('');
  }, [hideSuggestionBox]);

  useEffect(() => {
    if (!renderedFirstTime) {
      logger.trace('Showed copilot search results in apex help');
      setRenderedFirstTime(true);
    }
  }, [logger, renderedFirstTime]);

  return (
    <CopilotResultViewExternalSiteMap
      searchQuery={searchQuery}
      siteMap={allSiteMap}
      onCopilotClick={closeApexPopUp}
      i18n={i18n}
      placeholderText={_TL_('Your question')}
      logger={logger}
      source={HELP_APEX}
      isNewLogo={isNewLogo}
    />
  );
};

CopilotSearchResults.propTypes = {
  hideSuggestionBox: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  logger: PropTypes.shape({ error: PropTypes.func.isRequired, trace: PropTypes.func.isRequired }).isRequired,
  isNewLogo: PropTypes.bool,
};

CopilotSearchResults.defaultProps = {
  isNewLogo: false,
};
